/**
 * Custom logic for setting the correct device id.
 *
 * @param {unknown} _amplitude - The amplitude instance.
 * @returns {void}
 */
export function fixDeviceID(_amplitude) {
    return Promise.resolve();
}
